import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCaldas from '../components/MenuCaldas';
import Sponsors from '../components/Sponsors';
import Product from '../components/Product';
import Preinscription from '../components/Preinscription';
import ProgessTitle from '../components/ProgressTitle';
import useInputValue from '../hooks/useInputValue';
import '../assets/styles/containers/Register.sass';

const RegisterCaldas = () => {
  const [intro, setIntro] = useState({content_es: ''});
  const [phases, setPhases] = useState({content_es: ''});
  const [modal, setModal] = useState('none');
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [sponsors, setSponsors] = useState(null);
  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);
  const name = useInputValue('');
  const surname = useInputValue('');
  const email = useInputValue('');
  const country = useInputValue('');
  const phone = useInputValue('');
  const [category, setCategory] = useState('');
  const [errors, setErrors] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/register/caldas`)
    .then(data => data.json())
    .then(data => {
      setIntro(data.intro);
      setPhases(data.phases);
      setCategories(data.categories);
      setProducts(data.products);
      setSponsors(data.sponsors);
    })
    .catch(console.error('error'))
  }, []);

  useEffect(() => {
    const findTotal = cart.reduce(function (accumulator, current) {
      return accumulator + parseInt(current.price);
    }, 0);
    setTotal(findTotal);
  }, [cart]);

  const currency = (value) => {
    let thousands = "."
    let i = parseInt(value = Math.abs(Number(value) || 0)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
  }

  const handleAddItem = (event) => {
    event.preventDefault();
    let data = {
      "id": event.target.id.value,
      "item": event.target.item.value,
      "quantity": event.target.cantidad.value,
      "size": event.target.talla.value,
      "price": event.target.cantidad.value * event.target.price.value,
    }
    setCart([...cart, data],);
  }

  const handleDelete = (id) => {
    setCart(
      cart => cart.filter(item => item.id !== id)
    );
  };

  const handleRadio = (event, price) => {
    let data = {
      "id": 0,
      "item": event.target.value,
      "quantity": 1,
      "size": '-',
      "price": price,
    }
    setCart([data]);
    setCategory(event.target.value);
  }

  const handleSubmit = () => {
    let formData = new FormData();
    formData.append("name", name.value);
    formData.append("surname", surname.value);
    formData.append("email", email.value);
    formData.append("country", country.value);
    formData.append("phone", phone.value);
    formData.append("category", category);
    formData.append("products", JSON.stringify(cart));
    formData.append("value", total);
    formData.append("register_city", 'caldas');

    fetch(`${process.env.REACT_APP_URL}/preinscription`, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
      headers:{
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then(res => {
      if (res.errors) {
        return setErrors(res.errors);
      }
      return setSessionStorage();
    })
    .catch(err => {
      return setErrors(err)});
  }
  
  const setSessionStorage = () => {
    const save = {
      'id': name,
      'email': email
    };

    sessionStorage.setItem("la-leyenda", JSON.stringify(save));
    window.location.href = "/series/caldas/registro/completar-registro";
  }

  const handleOpenModal = () => {
    setModal('block');
  }

  const handleCloseModal = () => {
    setModal('none');
  }

  return (
    <Layout>
      <Banner id={13} city="caldas" thumb="/caldas/logo_caldas.png" />
      <MenuCaldas />
      <ProgessTitle step1="active" city="caldas"/>
      <div className="row content-caldas">
        <div className="container">

          {/* Table */}
          <div className="row"> 
            <div className="col-12">
              <div dangerouslySetInnerHTML={{ __html: phases.content_es}} />
            </div>
          </div>

          {/* Formulario */}
          <div className="row">
            <div className="col-12 py-3">
              <Preinscription
                categories={categories}
                name={name}
                surname={surname}
                email={email}
                country={country}
                phone={phone}
                handleRadio={handleRadio}
                errors={errors}
              />
            </div>
          </div>

          {/* Merchandise */}
          <div className="row">
            <div className="col-12 mb-3 text-justify">
              {intro.content_es}
            </div>
          </div>

          {/* Products */}
          <div className="row">
            {products.map((item, index) => {
              return (
                <div className="col-12 col-md-6 col-lg-4 wrap-product">
                  <Product handleOpenModal={handleOpenModal} handleSubmit={handleAddItem} {...item} />
                  <hr className="wrap-product-division"/>
                </div>
              )
            })}
          </div>

          {/* Carro */}
          <div class="row justify-content-end Cart">
            <div class="col-12 mb-4 text-center">
              <h2>CARRO DE COMPRAS</h2>
            </div>
            <div class="col-12">
              {cart.length > 0 ? (
                <table class="table Cart-table">
                  <thead>
                    <tr>
                      <th class="Cart-table-item --caldas">ITEM</th>
                      <th class="Cart-table-item --caldas">CANTIDAD</th>
                      <th class="Cart-table-item --caldas">TALLA</th>
                      <th class="Cart-table-item --caldas">PRECIO</th>
                      <th class="Cart-table-item --caldas"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart.map((item, index) => (
                      <tr kye={`ìndex-${index}`}>
                        <td>{item.item}</td>
                        <td>{item.quantity}</td>
                        <td>{item.size}</td>
                        <td><b>$ {currency(item.price)}</b></td>
                        <td>
                          <button
                            type="button"
                            aria-label="delete"
                            className="Cart-btn-delete"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </button>
                        </td>
                      </tr>
                    ))}
                    <tr className="Cart-table-total">
                      <td></td>
                      <td></td>
                      <td><span class="color-caldas">TOTAL</span></td>
                      <td><b>$ {currency(total)}</b></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <p>No tiene productos en el carro de compras</p>
              )}
            </div>
            <div class="col-12 col-md-3 mb-4">
              <button type="button" class="btn Cart-btn-continue --caldas" onClick={() => handleSubmit()}>CONTINUAR</button>
            </div>
          </div>

          {/* Modal tallas */}
          <div className="modal fade show" id="tallasModal" tabindex="-1" role="dialog" aria-labelledby="tallasModalLabel" aria-modal="true" style={{display: modal}}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="tallasModalLabel">Guía de Tallas kafitt</h5>
                  <button type="button" className="close" onClick={() => handleCloseModal()}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <img className="img-fluid" src="https://legendofeldorado.com/series-admin-temporal/img/tallas.jpg" alt="" />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => handleCloseModal()}>Cerrar</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      {sponsors &&
        <Sponsors
          customClass="--caldas"
          items={sponsors}
        />
      }
    </Layout>
  )

}

export default RegisterCaldas;
